import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-blue-small.component.scss';
import Slider from '../slider/slider.component';
var BannerBlueSmall = /** @class */ (function (_super) {
    tslib_1.__extends(BannerBlueSmall, _super);
    function BannerBlueSmall(element) {
        return _super.call(this, element) || this;
    }
    BannerBlueSmall.prototype.init = function () {
        this.sliderContainer = this.element.querySelector('.swiper-container');
        this.sliderPagination = this.element.querySelector('.swiper-pagination');
        this.sliderNext = this.element.querySelector('.swiper-button-next');
        this.sliderPrev = this.element.querySelector('.swiper-button-prev');
        this.sliderConfig = {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 0,
            pagination: {
                el: this.sliderPagination,
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: this.sliderNext,
                prevEl: this.sliderPrev
            },
            autoplay: {
                delay: 7000
            }
        };
        Slider.init(this.sliderContainer, this.sliderConfig);
    };
    BannerBlueSmall.prototype.bindEvents = function () { };
    return BannerBlueSmall;
}(Base));
export { BannerBlueSmall };



//////////////////
// WEBPACK FOOTER
// ./components/banner-blue-small/banner-blue-small.component.ts
// module id = 120
// module chunks = 0